export class SubscriptionCoupon {
  id: number;
  code: string;
  hour: boolean;
  discountMoney: number;
  discountPercent: number;
  minimumValueForUse: number;
  isMoneyDiscount: boolean;
  uniqueUser: boolean;
  maximumTotalUse: number;
  maximumTotalUseLeft: number;
  couponStatus: string;
  finality: string;
  singlePurchase: boolean;
  creationDate: number;

  toCouponFromValidate(couponValidate: CouponValidate): SubscriptionCoupon {
    const coupon: SubscriptionCoupon = new SubscriptionCoupon();
    coupon.code = couponValidate.couponCode;
    coupon.discountMoney = couponValidate.couponValue;
    coupon.discountPercent = couponValidate.couponPercentual;
    coupon.isMoneyDiscount = couponValidate.isMoney;
    coupon.minimumValueForUse = couponValidate.minimumValueForUse;
    coupon.finality = couponValidate.finalityType;
    coupon.maximumTotalUseLeft = couponValidate.maximumTotalUseLeft;
    return coupon;
  }
}

export class CouponValidate {
  couponCode: string;
  success: boolean;
  couponMessage: string;
  couponValue: number;
  couponPercentual: number;
  isMoney: boolean;
  minimumValueForUse: number;
  finalityType: string;
  maximumTotalUseLeft: number;
}



// WEBPACK FOOTER //
// ./src/app/shared/models/subscription-coupon.model.ts